import { fetchLoanCharges } from "../../store/reducers/dashboardSlice/api";
import { gridColumns_LoanCharges } from "../../Utils/TableColumnDefs";
import CommonGrid from "../CommonGrid";
import useFetchTableData from "../../useFetchTableData";

const LoanChargesTables = ({ className = "", footer = true, viewAllModal = true }) => {
  const { data, status, retry } = useFetchTableData(fetchLoanCharges, "loanCharges");
  const loanChargesFilter = [
    {
      name: "Deferred",
      key: "Deferred",
      type: "select",
      options: [
        { label: "All", value: "all" },
        { label: "Defered", value: "Yes" },
        { label: "Non-deferd", value: "No" },
      ],
    },
  ];
  return (
    <CommonGrid
      className={`col-sm-6 ${className}`}
      title={"Loan Charges"}
      gridColumns={gridColumns_LoanCharges}
      columnData={data}
      status={status}
      onRetry={retry}
      footer={footer}
      viewAllModal = {viewAllModal}
      filterOption={loanChargesFilter}
      tableTotal={["Unpaid Balance"]}
    />
  );
};

export default LoanChargesTables;
